<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close basic-close" (click)="onClose()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form autocomplete="off" [formGroup]="form" (ngSubmit)="onConfirme()">
  <div class="modal-body">
    <div class="col-md-12">
      <div class="row">
        <span class="badge badge-success my-2 f-14 formBadge width"> Sélection du client </span>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <div class="row">
              <div class="col-md-4">
                <app-entity-finder [class]="'Customer'" [groups]="['customer']" [required]="true" [label]="'Client'"
                  (uuid)="setCustomerUuid($event)" [selected]="customerSelected" [disabled]="edit"
                  [placeholder]="'Sélectionnez un client'">
                </app-entity-finder>
                <div class="invalid-feedback" *ngIf="submit && f.customer.errors">
                  <div *ngIf="f.customer.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-4">
                <label for="type">Type facture <span class="asterix">*</span></label>
                <select *ngIf="!edit" [attr.disabled]="form.value.customer ? null : ''" class="form-control" id="type"
                  #mySelectTypeFacture formControlName="type" (change)="loadFolders()" placeholder="Faire un choix"
                  [ngClass]="{
                  'is-invalid': submit && f.type.errors,
                  'is-valid': submit && f.type.valid
                }">
                <option value="null" selected> Sélectionnez un type de facture</option>
                  <option *ngFor="let item of typeFactureRow" [ngValue]="item.value">{{item.label}}</option>
                </select>
                <input *ngIf="edit" type="text" class="form-control p-2 text-uppercase font-weight-bold text-secondary"
                  [value]="payment?.invoice?.type" readonly>
                <div class="invalid-feedback" *ngIf="submit && f.type.errors">
                  <div *ngIf="f.type.errors.required">{{required.novide}}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div *ngIf="!edit && isLoadingFolder" class="spinner-container">
                  <div class="spinner"></div>
                </div>
                <label for="folder">Dossier <span class="asterix">*</span></label>
                <select *ngIf="!edit" (change)="setFolderUuid($event)" formControlName="folder" class="form-control"
                  id="folder" [attr.disabled]="f.type.value ? null : 'true'"
                  [ngClass]="{'is-invalid': submit && f.folder.errors,'is-valid': submit && f.folder.valid}">
                  <option value="null" selected> Sélectionnez un dossier</option>
                  <option *ngFor="let item of folders" [value]="item?.uuid">{{item?.libelle}}</option>
                </select>
                <input *ngIf="edit" type="text" class="form-control p-2 text-uppercase font-weight-bold text-secondary"
                  [value]="payment?.invoice?.folder?.libelle" readonly>
                <div class="invalid-feedback" *ngIf="submit && f.folder.errors">
                  <div *ngIf="f.folder.errors.required">{{required.novide}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ✅ NOUVEAU : Affichage du wallet client compact -->
      <div class="row" *ngIf="wallet && f.customer.value">
        <div class="col-md-12">
          <app-wallet-display [customerUuid]="f.customer.value" [compact]="true"></app-wallet-display>
        </div>
      </div>

      <!-- AFFICHAGE DES RESULATS DE LA RECHERCHE -->
      <div *ngIf="f.folder.value">
        <!-- ✅ Facture masquée car sélection automatique -->
        <div class="col-sm-12" formArrayName="options" style="display: none;">
          <div *ngFor="let item of option.controls; let i = index" [formGroupName]="i">
            <input formControlName="checked" type="checkbox" id="checked{{i}}">
            <input formControlName="libelle" type="text" id="libelle{{i}}">
            <input formControlName="uuid" type="text" id="uuid{{i}}">
          </div>
        </div>

        <!-- ✅ NOUVEAU : Résumé de la facture (compact) -->
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="card bg-light border-primary">
              <div class="card-body p-3">
        <div class="row">
                  <div class="col-md-3">
                    <small class="text-muted">Dossier</small>
                    <p class="mb-0 font-weight-bold">{{ folder?.numero || folder?.code }}</p>
                  </div>
                  <div class="col-md-3">
                    <small class="text-muted">Montant total</small>
                    <p class="mb-0 font-weight-bold text-primary">{{ montantTotal | number }} {{global.device}}</p>
                  </div>
                  <div class="col-md-3">
                    <small class="text-muted">Déjà payé</small>
                    <p class="mb-0 font-weight-bold text-success">{{ montantRegle | number }} {{global.device}}</p>
                  </div>
                  <div class="col-md-3">
                    <small class="text-muted">Reste à payer</small>
                    <p class="mb-0 font-weight-bold text-danger">{{ montantRestant | number }} {{global.device}}</p>
                  </div>
                </div>
                <div class="row mt-2" *ngIf="folder?.modalite === 'ECHEANCE'">
                  <div class="col-md-12">
                    <small class="text-muted">
                      <i class="fas fa-info-circle mr-1"></i>
                      Modalité : <strong>Échéancier</strong> - {{ echeanceFolders.length }} échéance(s) due(s) pour {{ montantEcheancesDues | number }} {{global.device}}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- Sélecteur du type de paiement (Loyer / Charges / Les deux) -->
        <div class="col-md-12 mb-3" *ngIf="folder?.modalite === 'ECHEANCE' && echeanceFolders.length > 0 && !edit">
          <div class="row">
            <span class="badge badge-success my-2 f-14 formBadge width">
              <i class="fas fa-tags mr-2"></i>
              Type de paiement
            </span>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="btn-group btn-group-toggle w-100">
                <label class="btn btn-outline-primary"
                       [class.active]="typePaiement === 'LOYER_ET_CHARGES'"
                       (click)="onTypePaiementChange('LOYER_ET_CHARGES')">
                  <i class="fas fa-home mr-1"></i>
                  Loyer + Charges
                </label>
                <label class="btn btn-outline-primary"
                       [class.active]="typePaiement === 'LOYER_SEUL'"
                       (click)="onTypePaiementChange('LOYER_SEUL')">
                  <i class="fas fa-key mr-1"></i>
                  Loyer uniquement
                </label>
                <label class="btn btn-outline-primary"
                       [class.active]="typePaiement === 'CHARGES_SEULES'"
                       (click)="onTypePaiementChange('CHARGES_SEULES')">
                  <i class="fas fa-bolt mr-1"></i>
                  Charges uniquement
                </label>
              </div>
              <small class="text-muted d-block mt-2">
                <i class="fas fa-info-circle mr-1"></i>
                <span *ngIf="typePaiement === 'LOYER_ET_CHARGES'">
                  Le paiement sera réparti proportionnellement entre le loyer et les charges.
                </span>
                <span *ngIf="typePaiement === 'LOYER_SEUL'">
                  Le paiement sera affecté uniquement au loyer (mensualité de base).
                </span>
                <span *ngIf="typePaiement === 'CHARGES_SEULES'">
                  Le paiement sera affecté uniquement aux charges.
                </span>
              </small>
            </div>
          </div>
        </div>

        <!-- ✅ NOUVEAU : Saisie du montant et choix de répartition -->
        <div class="col-md-12" *ngIf="!edit">
        <div class="row">
          <span class="badge badge-success my-2 f-14 formBadge width">
              <i class="fas fa-money-bill-wave mr-2"></i>
              Montant et répartition
          </span>
        </div>
          
          <!-- Saisie du montant -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="montantVerser">Montant à verser <span class="asterix">*</span></label>
              <input 
                type="number" 
                step="1000" 
                formControlName="montant" 
                class="form-control form-control-lg text-right font-weight-bold text-primary" 
                id="montantVerser" 
                placeholder="Saisissez le montant"
                (input)="onMontantChange()"
                [ngClass]="{
                  'is-invalid': submit && f.montant.errors,
                  'is-valid': submit && f.montant.valid && f.montant.value > 0
                }">
              <div class="invalid-feedback" *ngIf="submit && f.montant.errors">
                <div *ngIf="f.montant.errors.required">{{required.novide}}</div>
              </div>
              <small class="text-muted">
                <i class="fas fa-info-circle mr-1"></i>
                Saisissez le montant que le client souhaite verser
                <span *ngIf="wallet && wallet.creditDisponible > 0" class="badge badge-info ml-1">
                  ou 0 pour wallet uniquement
                </span>
                <span *ngIf="loadingWallet" class="badge badge-warning ml-1">
                  <i class="fas fa-spinner fa-spin"></i> Chargement wallet...
            </span>
              </small>
              
              <!-- ✅ Message d'information pour paiement wallet uniquement -->
              <div class="alert alert-success mt-2 mb-0" *ngIf="f.montant.value === 0 && utiliserWallet && wallet && wallet.creditDisponible > 0">
                <i class="fas fa-check-circle mr-2"></i>
                <strong>Paiement 100% Wallet activé !</strong><br>
                <small>
                  Vous utilisez <strong>{{wallet.creditDisponible | number}} FCFA</strong> de crédit wallet 
                  sans versement physique d'argent.
                </small>
              </div>
              
              <!-- ⚠️ Message si montant = 0 mais wallet vide -->
              <div class="alert alert-warning mt-2 mb-0" *ngIf="f.montant.value === 0 && wallet && wallet.creditDisponible <= 0">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                <strong>Wallet vide</strong><br>
                <small>
                  Le client n'a pas de crédit disponible sur son wallet (0 FCFA). Veuillez saisir un montant.
                </small>
              </div>
              
              <!-- ⚠️ Message si montant = 0 mais wallet pas encore chargé -->
              <div class="alert alert-info mt-2 mb-0" *ngIf="f.montant.value === 0 && !wallet && !loadingWallet && f.customer.value">
                <i class="fas fa-info-circle mr-2"></i>
                <small>
                  Le wallet du client n'a pas pu être chargé. Veuillez recharger la page ou saisir un montant.
                </small>
              </div>
            </div>
            
            <!-- Utiliser le wallet -->
            <div class="col-md-6" *ngIf="wallet && wallet.creditDisponible > 0">
              <label>&nbsp;</label>
              <div class="card bg-success-light border-success">
                <div class="card-body p-3">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="utiliserWalletCheckbox"
                      name="utiliserWalletInput"
                      [(ngModel)]="utiliserWallet"
                      [ngModelOptions]="{standalone: true}"
                      (change)="onUtiliserWalletChange()"
                    >
                    <label class="custom-control-label font-weight-bold" for="utiliserWalletCheckbox">
                      <i class="fas fa-wallet mr-2"></i>
                      Utiliser le crédit wallet
                    </label>
                  </div>
                  <small class="text-success d-block mt-1">
                    <i class="fas fa-coins mr-1"></i>
                    {{ formatMontant(wallet.creditDisponible) }} disponible
                  </small>
                  <!-- Champ montant wallet personnalisé -->
                  <div *ngIf="utiliserWallet" class="mt-2">
                    <label class="small font-weight-bold mb-1">Montant à utiliser du wallet :</label>
                    <input
                      type="number"
                      step="1000"
                      class="form-control form-control-sm"
                      [(ngModel)]="montantWalletSaisi"
                      [ngModelOptions]="{standalone: true}"
                      [max]="wallet.creditDisponible"
                      [min]="0"
                      placeholder="Montant wallet"
                      (input)="onMontantWalletChange()">
                    <small class="text-muted">Max : {{ formatMontant(wallet.creditDisponible) }}</small>
                  </div>
                </div>
              </div>
            </div>
        </div>

          <!-- Mode de répartition (uniquement pour échéancier) -->
          <div class="row mb-3" *ngIf="folder?.modalite === 'ECHEANCE' && echeanceFolders.length > 0">
            <div class="col-md-12">
              <label><i class="fas fa-sliders-h mr-2"></i>Mode de répartition</label>
              <div class="btn-group btn-group-toggle w-100">
                <label class="btn btn-outline-primary" [class.active]="modeRepartition === 'AUTOMATIQUE'" (click)="changeModeRepartition('AUTOMATIQUE')">
                  <i class="fas fa-magic mr-1"></i>
                  Répartition automatique
                </label>
                <label class="btn btn-outline-primary" [class.active]="modeRepartition === 'MANUELLE'" (click)="changeModeRepartition('MANUELLE')">
                  <i class="fas fa-hand-pointer mr-1"></i>
                  Sélection manuelle
                </label>
              </div>
              <small class="text-muted d-block mt-2">
                <i class="fas fa-info-circle mr-1"></i>
                <span *ngIf="modeRepartition === 'AUTOMATIQUE'">
                  Le montant sera automatiquement réparti sur les échéances par ordre de date. Le surplus ira sur votre wallet.
                </span>
                <span *ngIf="modeRepartition === 'MANUELLE'">
                  Sélectionnez les échéances que vous souhaitez payer. Le surplus ira sur votre wallet.
            </span>
              </small>
                      </div>
                    </div>

          <!-- ✅ RECAP FINAL : Utilisation wallet + Répartition + Surplus -->
          <div class="row mb-3" *ngIf="f.montant.value > 0 || (utiliserWallet && montantWalletUtilise > 0) || echeanceFolders.length > 0">
            <div class="col-md-12">
              <div class="card border-primary">
                <div class="card-header bg-primary text-white">
                  <h6 class="mb-0">
                    <i class="fas fa-receipt mr-2"></i>
                    Récapitulatif du paiement
                  </h6>
                </div>
                <div class="card-body">
                  <table class="table table-sm table-borderless mb-0">
                    <tr>
                      <td><strong>Montant versé (espèces/chèque/etc.) :</strong></td>
                      <td class="text-right h5 text-primary mb-0">{{ f.montant.value | number }} {{global.device}}</td>
                    </tr>
                    <tr *ngIf="utiliserWallet && montantWalletUtilise > 0" class="text-success">
                      <td>
                        <i class="fas fa-wallet mr-1"></i>
                        <strong>+ Crédit wallet utilisé :</strong>
                      </td>
                      <td class="text-right text-success font-weight-bold">+{{ montantWalletUtilise | number }} {{global.device}}</td>
                    </tr>
                    <tr class="border-top bg-light">
                      <td class="font-weight-bold h6 mb-0">
                        <i class="fas fa-coins mr-1"></i>
                        <strong>Montant TOTAL disponible :</strong>
                      </td>
                      <td class="text-right font-weight-bold h5 text-success mb-0">
                        {{ (f.montant.value || 0) + (utiliserWallet ? montantWalletUtilise : 0) | number }} {{global.device}}
                      </td>
                    </tr>
                    <tr *ngIf="montantEcheancesSelectionnees > 0" class="border-top">
                      <td>
                        <i class="fas fa-check-square mr-1"></i>
                        <strong>Total échéances sélectionnées :</strong>
                      </td>
                      <td class="text-right h6 text-info mb-0">{{ montantEcheancesSelectionnees | number }} {{global.device}}</td>
                    </tr>
                  </table>

                  <!-- Total échéances sélectionnées (mode manuel) -->
                  <table class="table table-sm table-borderless mb-0" *ngIf="modeRepartition === 'MANUELLE' && montantEcheancesSelectionnees > 0">
                    <tr class="border-top">
                      <td><strong><i class="fas fa-check-square mr-1"></i>Total échéances sélectionnées :</strong></td>
                      <td class="text-right h5 text-info mb-0">{{ montantEcheancesSelectionnees | number }} {{global.device}}</td>
                    </tr>
                  </table>

                  <!-- Preview répartition -->
                  <div *ngIf="repartitionPreview.length > 0" class="mt-3">
                    <hr>
                    <h6>
                      <i class="fas fa-{{ modeRepartition === 'AUTOMATIQUE' ? 'magic' : 'hand-pointer' }} mr-2"></i>
                      Répartition {{ modeRepartition === 'AUTOMATIQUE' ? 'automatique' : 'manuelle' }}
                    </h6>
                    <table class="table table-sm table-bordered mb-0">
                      <thead class="thead-light">
                        <tr>
                          <th>Date</th>
                          <th>Montant échéance</th>
                          <th>Montant affecté</th>
                          <th>Statut</th>
                </tr>
              </thead>
                      <tbody>
                        <tr *ngFor="let item of repartitionPreview">
                          <td>{{ item.date | date:'dd/MM/yyyy' }}</td>
                          <td>{{ item.montantEcheance | number }} {{global.device}}</td>
                          <td class="font-weight-bold text-success">{{ item.montantAffecte | number }} {{global.device}}</td>
                          <td>
                            <span class="badge" [ngClass]="item.type === 'COMPLET' ? 'badge-success' : 'badge-warning'">
                              {{ item.type }}
                            </span>
                  </td>
                </tr>
              </tbody>
            </table>
        </div>

                  <!-- Affichage du SURPLUS (toujours visible si > 0) -->
                  <div *ngIf="montantSurplus > 0" class="alert alert-success mt-3 mb-0">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-piggy-bank fa-2x mr-3 text-success"></i>
                      <div>
                        <h6 class="mb-1">
                          <i class="fas fa-arrow-up mr-1"></i>
                          Surplus crédité au wallet
                        </h6>
                        <p class="mb-0 h4 text-success font-weight-bold">
                          + {{ montantSurplus | number }} {{global.device}}
                        </p>
                        <small class="text-muted">
                          Ce montant sera automatiquement ajouté au wallet du client et pourra être utilisé pour les prochains paiements.
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                      </div>
                    </div>
          </div>
        </div>

        <!-- Tableau des échéances -->
        <div class="col-sm-12" *ngIf="echeanceFolders.length > 0">
          <span class="badge badge-success my-2 f-14 formBadge width">
            <i class="fas fa-{{ modeRepartition === 'AUTOMATIQUE' ? 'magic' : 'hand-pointer' }} mr-2"></i>
            {{ modeRepartition === 'MANUELLE' ? 'Sélectionnez les échéances à payer' : 'Échéances dues' }}
          </span>
        </div>
        <div class="col-sm-12" *ngIf="echeanceFolders.length > 0" formArrayName="echeanceFolders">
          <div class="form-group">
            <table class="table table-striped table-bordered table-hover">
              <thead class="thead-light">
                <tr>
                  <th width="50" *ngIf="modeRepartition === 'MANUELLE'">
                      <div class="form-check">
                      <input class="form-check-input" id="selectAllEcheancesManuel" type="checkbox"
                          (change)='onSelectAllEcheance($event)'>
                    </div>
                  </th>
                  <th>Date</th>
                  <th>État</th>
                  <th>Description</th>
                  <th class="text-right" *ngIf="typePaiement === 'LOYER_ET_CHARGES'">Loyer</th>
                  <th class="text-right" *ngIf="typePaiement === 'LOYER_ET_CHARGES'">Charges</th>
                  <th class="text-right">Montant</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of echeanceFolders.controls; let i = index" [formGroupName]="i"
                    [ngClass]="{'table-success': item.get('checked').value}">
                  <td *ngIf="modeRepartition === 'MANUELLE'">
                      <div class="form-check">
                      <input
                        formControlName="checked"
                        class="form-check-input"
                        type="checkbox"
                        id="echeanceManuelCheck{{i}}"
                        (change)="onEcheanceCheckChange()">
                    </div>
                  </td>
                  <td>{{ item.get('date').value | date:'dd/MM/yyyy' }}</td>
                  <td>
                    <span class="badge" [ngClass]="item.get('etat').value === 'IMPAYE' ? 'badge-danger' : 'badge-warning'">
                      {{ item.get('etat').value }}
                    </span>
                  </td>
                  <td>{{ item.get('description').value || 'Échéance #' + (i + 1) }}</td>
                  <td class="text-right text-info" *ngIf="typePaiement === 'LOYER_ET_CHARGES'">{{ item.get('mensualiteBase').value | number }} {{global.device}}</td>
                  <td class="text-right text-warning" *ngIf="typePaiement === 'LOYER_ET_CHARGES'">{{ item.get('charge').value | number }} {{global.device}}</td>
                  <td class="font-weight-bold text-right">{{ item.get('montant').value | number }} {{global.device}}</td>
                </tr>
              </tbody>
            </table>
            
            <!-- Total des échéances sélectionnées -->
            <div class="alert alert-info" *ngIf="montantEcheancesSelectionnees > 0">
              <i class="fas fa-calculator mr-2"></i>
              <strong>Total échéances sélectionnées : {{ montantEcheancesSelectionnees | number }} {{global.device}}</strong>
            </div>

            <!-- Affichage du surplus en mode manuel -->
            <div *ngIf="montantSurplus > 0" class="alert alert-success">
              <i class="fas fa-piggy-bank mr-2"></i>
              <strong>Surplus qui sera crédité au wallet : {{ montantSurplus | number }} {{global.device}}</strong>
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <span *ngIf="avanceFolders.length > 0" class="badge badge-success my-2 f-14 formBadge width"> DÉTAILS DE
            L'ÉTAT D'AVANCEMENT </span>
        </div>
        <div class="col-sm-12" *ngIf="avanceFolders.length > 0" formArrayName="avanceFolders">
          <div class="form-group">
            <table id="invoices" class="table table-sm table-striped table-bordered nowrap table-hover">
              <thead>
                <tr>
                  <th *ngIf="!edit">
                    <div class="form-group">
                      <div class="form-check">
                        <input class="form-check-input" id="selectAll" type="checkbox"
                          (change)='onSelectAllAdvance($event)'>
                      </div>
                    </div>
                  </th>
                  <th class="col-sm-5">Libellé</th>
                  <th>Pourcentage (%)</th>
                  <th class="col-sm-5">État</th>
                  <th class="col-sm-5">Montant</th>
                </tr>
              </thead>
              <tbody class="task-page">
                <tr *ngFor="let item of avanceFolders.controls; let i = index" [formGroupName]="i">
                  <td *ngIf="!edit">
                    <div class="form-group">
                      <div class="form-check">
                        <input formControlName="checked" class="form-check-input" type="checkbox" id="checked{{i}}">
                      </div>
                    </div>
                  </td>
                  <td class="col-sm-5"><input formControlName="libelle" type="text" class="form-control p-2 bold"
                      id="libelle{{i}}"></td>
                  <td><input formControlName="prc" type="text" class="form-control p-2 bold" id="prc{{i}}"></td>
                  <td class="col-sm-5"><input formControlName="etat" type="text" class="form-control p-2 bold"
                      id="etat{{i}}"></td>
                  <td class="col-sm-5"><input [value]="item.get('montant').value |number" type="text"
                      class="form-control p-2 bold" readonly id="montant{{i}}"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Sélection de la facture A REGLER -->
        <div class="row">
          <span class="badge badge-success my-2 f-14 formBadge width"> Détails du règlement </span>
        </div>
        <!-- DÉTAILS DU PAIEMENT -->
        <div class="row">
          <div class="col-md-3">
            <label for="date">Date de paiement <span class="asterix">*</span></label>
            <input type="date" formControlName="date" class="form-control" id="date" [ngClass]="{
              'is-invalid': submit && f.date.errors,
              'is-valid': submit && f.date.valid
            }">
            <div class="invalid-feedback" *ngIf="submit && f.date.errors">
              <div *ngIf="f.date.errors.required">{{required.novide}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="mode">Mode de paiement <span class="asterix">*</span></label>
            <select (change)="onChangeLibelle()" class="form-control" formControlName="mode" id="mode" [ngClass]="{
              'is-invalid': submit && f.mode.errors,
              'is-valid': submit && f.mode.valid
            }">
              <option *ngFor="let item of modeRow" [value]="item.value">{{item.label}}</option>
            </select>
            <div class="invalid-feedback" *ngIf="submit && f.mode.errors">
              <div *ngIf="f.mode.errors.required">{{required.novide}}</div>
            </div>
          </div>
          <div class="col-md-3">
            <label for="effectue">Effectué par <span class="asterix">*</span></label>
            <select (change)="onChangeEffectue()" class="form-control" formControlName="effectue" id="effectue"
              [ngClass]="{
              'is-invalid': submit && f.effectue.errors,
              'is-valid': submit && f.effectue.valid
            }">
              <option [value]="'LUI MEME'">LUI MÊME</option>
              <option [value]="'AUTRE'">Autre</option>
            </select>
          </div>
          <div class="col-md-3" *ngIf="f.effectue.value === 'AUTRE'">
            <label for="tiers">Tiers <span class="asterix">*</span></label>
            <input type="text" formControlName="tiers" class="form-control" id="tiers" placeholder="Nom du tiers">
          </div>
          <div class="col-md-3" *ngIf="f.mode.value !== 'ESPECE'">
            <label for="source">{{ sourceTitle }}</label>
            <input type="text" formControlName="source" class="form-control" id="source" [placeholder]="sourceTitle">
          </div>
          <div class="col-md-3" *ngIf="f.mode.value !== 'ESPECE'">
            <label for="numero">{{ numeroTitle }}</label>
            <input type="text" formControlName="numero" class="form-control" id="numero" [placeholder]="numeroTitle">
          </div>
        </div>
        <!-- ✅ Déplacé plus haut dans "Montant et répartition" -->
        <!-- Ancien bloc de saisie du montant supprimé, voir nouvelle section ci-dessus -->

        <!-- Pièces jointes -->
        <div class="row">
          <span class="badge badge-success my-2 f-14 formBadge width"> Pièces jointes </span>
        </div>
        <div class="form-group">
          <div class="row mb-2">
            <div class="col-md">
              <label>Pièces et documents à joindre</label>
              <app-folder-uploader (filesd)="files($event)" [maxSize]="3" (filesUploaded)="setParam('folderUuid',$event)"
                [path]="'paiement_client'" [etat]="edit ? 'edit': 'add'"
                [folder]="edit && payment ? payment?.folder : null">
              </app-folder-uploader>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="onClose()" type="button" class="btn btn-secondary text-left" data-dismiss="modal">
      Fermer <i class="feather icon-x-circle"></i>
    </button>
    <button (click)="form.reset()" type="button" class="btn btn-warning">
      Vider <i class="fas fa-broom"></i>
    </button>
    <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
      Enregistrer <i class="feather icon-save"></i>
    </button>
  </div>
</form>
